import React, { Fragment, useState, useEffect } from "react";
import HeaderComponent from "../../components/HeaderComponent";
import TitleH2Component from "../../components/TitleH2Component";
import InputComponent from "../../components/InputComponent";
import stylebtn from "../../styles/btn.module.scss";
import { Icon } from "@iconify/react/dist/iconify.js";
import ParrafoComponent from "../../components/ParrafoComponent";
import ModalGeneralComponent from "../../components/ModalGeneralComponent";
import styleform from "../../styles/form.module.scss";
import LoaderComponent from "../../components/LoaderComponent";
import AlertComponent from "../../components/AlertComponent";
import MoneyInputComponent from "../../components/MoneyInputComponent";
import TitleH4Component from "../../components/TitleH4Component";
import stylegeneral from "../../styles/general.module.scss";
import {
  BuscarCliente,
  postAbonoVR,
  PostCliente,
  PostventaRapida,
  postventaRapidaDetalle,
} from "../../api/ApiVenta";
import { EditarPersona, PostPersona } from "../../api/Empleado";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import SelectComponent from "../../components/SelectComponent";
import { getTransporte } from "../../api/transporte";
import TextAreaComponent from "../../components/TextAreaComponent";
import { abrirPdfVentasRapidas } from "../../api/Pdf";
const VentaRapidasPages = () => {
  const [showEliminar, setShowEliminar] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [mensaje, setMensaje] = useState("");
  const [alert, setAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);
  const [mensajealerta, setMensajealerta] = useState("");
  const [ventaR, setventaR] = useState([]);
  const [totalventas, setTotalVentas] = useState(0);
  const [totalPendiente, setTotalPendiente] = useState(0);
  const [currentItemIndex, setCurrentItemIndex] = useState(0);
  const [showventa, setShowVenta] = useState(false);
  const [idfactura, serIdfactura] = useState(null);
  const [currentPersona, setCurrentPersona] = useState([]);
  const [idCliente, setIdCliente] = useState("");
  const [currentCliente, setCurrentCliente] = useState([]);
  const [control, setControl] = useState(false);
  const [searchParams] = useSearchParams();
  const [transporteID, setTransporteID] = useState("")
  const { idUser } = useAuth();
  const [descripcionAbono, setDescripcionAbono] = useState("");
  const [fecha_abono, setFecha_abono] = useState(null);
  const [hora_abono, setHora_abono] = useState(null);
  const tipoVenta = searchParams.get("tipo");
  const { isSuper } = useAuth();
const navigate = useNavigate();
  let isTipo = "venta";
  const [dataTransporte, setDatTransporte] = useState([]);
  if (tipoVenta === "cotizacion") {
    isTipo = "cotizacion";
  } else if (tipoVenta === "elaboracion") {
    isTipo = "elaboracion";
  } else {
    isTipo = "venta"
  }

  const [formData, setFormData] = useState({
    producto: "",
    cantidad: "",
    precioUnidad: "",
    subtotal: "",
    pendiente_entrega: "",
  });

  const [formDataCliente, setFormDataCliente] = useState({
    id_user: idUser,
    fecha_vencimiento: null,
    nombre: "",
    cedula: "",
    direccion: "",
    telefono: "",
    descuento: 0,
    transporte: 0,
    total_pagado: 0,
    fecha_creacion: null,
    nombre_conductor: "",
    celular_conductor: "",
    quien_recibe: "",
    tipo: isTipo,
    descripcionElaboracion: "",

  });

  const [formDataPersona, setFormDataPersona] = useState({
    cedula: "",
    nombre: "",
    apellido: "",
    direccion: "",
    celular: "",
  });

  const handleCloseVenta = () => {
    setShowVenta(false);
  };


  //Metodo para capturar los valotes de la descripcion
  const handleChangeDescripcion = (event) => {
    setDescripcionAbono(event.target.value);
  };

  // Este es el metodo  para capturar el valor de las fechas de los abonos
  const handleChangeFechaAbono = (event) => {
    setFecha_abono(event.target.value);
  };

  // Este es el metodo para capturar la hora de los abonos
  const handleChangeHoraAbono = (event) => {
    setHora_abono(event.target.value);
  };

  // Manejar el cambio en el input
  const handleInputChangePersona = (event) => {
    const { name, value } = event.target;
    setFormDataPersona({
      ...formDataPersona,
      [name]: value,
    });
  };


  // Metodos para el popup de eliminar
  const handleCloseEliminar = () => setShowEliminar(false);

  // Metodos para el popup de eliminar
  const handleCloseEdit = () => {
    setShowEdit(false);
    setFormData({
      producto: "",
      cantidad: "",
      precioUnidad: "",
      subtotal: "",
      descuento: "",
      pendiente_entrega: "",
    });
  };

  const itemsPerPage = 7;
  const pageCount = Math.ceil(data.length / itemsPerPage);
  const currentPageDatacm = data.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  // Manejar el cambio en el input
  const handleInputChangeCliente = (e) => {
    const { name, value } = e.target;
    setFormDataCliente((prev) => ({
      ...prev,
      [name]: name === "total_pagado" ? Number(value) : value, // 👈 convierte a número solo este campo
    }));
  };

  // Manejar el cambio en el input
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // este es el metodo para sacar el valor del check
  const handleCheckboxChange = (event) => {
    const { id, checked } = event.target;
    setCheckboxes((prevCheckboxes) => ({
      ...prevCheckboxes,
      [id]: checked,
    }));

    // ✅ Limpiar campos relacionados cuando se desmarca "isCheckedpago"
    if (id === "isCheckedpago" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        total_pagado: 0,
        fecha_vencimiento: null,
      }));

      setDescripcionAbono("");
      setFecha_abono(null);
      setHora_abono(null);
    }

    // ✅ Limpiar campos relacionados cuando se desmarca "istransporte"
    if (id === "istransporte" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        transporte: 0,
      }));
    }

    // ✅ Limpiar campos relacionados cuando se desmarca "isCheckedDescuento"
    if (id === "isCheckedDescuento" && !checked) {
      setFormDataCliente((prev) => ({
        ...prev,
        descuento: 0,
      }));
    }

    const handleCheckboxChange = (event) => {
      const { id, checked } = event.target;
      setCheckboxes((prevCheckboxes) => ({
        ...prevCheckboxes,
        [id]: checked,
      }));


      // ✅ Limpiar descripción
      if (id === "isCheckedDescripcion" && !checked) {
        setFormData((prev) => ({
          ...prev,
          descripcionElaboracion: "",
        }));
      }
    };
  };

  /* // ✅ Limpiar campos relacionados cuando se desmarca "isCheckedDescuento"
    if (id === "isCheckedDescripcion" && !checked) {
      setFormData((prev) => ({
        ...prev,
        descripcionElaboracion: "",
      }));
    }
  }; */



  const [checkboxes, setCheckboxes] = useState({
    isChecked: false,
    isCheckedDescuento: false,
    isCheckedpago: false,
    isCheckedPendiente: false,
    istransporte: false,
    debeActualizarCliente: false,
    isCheckedDescripcion: false,
  });

  // metodo para agregar venta rapidas
  const aggVentarapida = () => {
    const cantidadNum = Number(formData.cantidad);
    const pendienteNum = Number(formData.pendiente_entrega) || 0;
    const precioNum = Number(formData.precioUnidad);
    //    const descuentoNum = Number(formData.descuento);

    // Validaciones
    if (!formData.producto || !cantidadNum || !precioNum) {
      setMensaje("Los campos son obligatorios **");
      setTimeout(() => setMensaje(""), 3000);
      return;
    }

    if (cantidadNum < pendienteNum) {
      setMensaje(
        "La cantidad pendiente por entregar no puede ser mayor a la cantidad vendida"
      );
      setTimeout(() => setMensaje(""), 3000);
      return;
    }

    const ventaActual = JSON.parse(localStorage.getItem("ventaRapida")) || [];

    // Verificar si el producto ya existe
    const productoExistente = ventaActual.find(
      (item) => item.producto === formData.producto
    );

    if (productoExistente) {
      // Actualizar cantidades
      const nuevaCantidad = productoExistente.cantidad + cantidadNum;
      const nuevaPendiente = productoExistente.pendiente_entrega + pendienteNum;

      productoExistente.cantidad = nuevaCantidad;
      productoExistente.pendiente_entrega = nuevaPendiente;
      productoExistente.subtotal = nuevaCantidad * precioNum;
    } else {
      // Crear nuevo producto
      const nuevoProducto = {
        producto: formData.producto,
        cantidad: cantidadNum,
        pendiente_entrega: pendienteNum,
        precioUnidad: precioNum,
        subtotal: cantidadNum * precioNum,
      };
      ventaActual.push(nuevoProducto);
    }

    // Guardar y actualizar estado
    localStorage.setItem("ventaRapida", JSON.stringify(ventaActual));
    setventaR(ventaActual);

    // Resetear formulario
    setFormData({
      producto: "",
      cantidad: "",
      precioUnidad: "",
      subtotal: "",
      descuento: "",
      pendiente_entrega: "",
    });

    setMensaje(""); // limpiar mensaje si existía
  };

  useEffect(() => {
    const ventaActual = JSON.parse(localStorage.getItem("ventaRapida")) || [];
    setventaR(ventaActual);
  }, []);

  // calculamos el total de la compra
  useEffect(() => {
    const calcularTotales = (ventaR) => {
      return ventaR.reduce(
        (acc, item) => {
          acc.total += item.subtotal;
          acc.pendiente += Number(item.pendiente_entrega) || 0; // 👈 asumo que este es el campo
          return acc;
        },
        { total: 0, pendiente: 0 }
      );
    };

    const { total, pendiente } = calcularTotales(ventaR);

    setTotalVentas(total);
    setTotalPendiente(pendiente); // 👈 otro estado para guardar el pendiente
  }, [ventaR]);

  const handleShowEdit = (item, index) => {
    setFormData({
      producto: item.producto,
      cantidad: item.cantidad,
      precioUnidad: item.precioUnidad,
      pendiente_entrega: item.pendiente_entrega,
    });
    setCurrentItem(item);
    setCurrentItemIndex(index);
    setShowEdit(true);
  };

  // editar
  const editarVentaRapida = () => {
    const index = currentItemIndex; // 👈 el índice real del item que estás editando
    const ventaActual = JSON.parse(localStorage.getItem("ventaRapida")) || [];

    if (index >= 0 && index < ventaActual.length) {
      const nuevosDatos = {
        ...formData,
        subtotal: Number(formData.cantidad) * Number(formData.precioUnidad), // 👈 recalculado siempre
      };

      ventaActual[index] = {
        ...ventaActual[index],
        ...nuevosDatos,
      };

      localStorage.setItem("ventaRapida", JSON.stringify(ventaActual));
      setventaR(ventaActual);
      setShowEdit(false);

      setFormData({
        producto: "",
        cantidad: "",
        precioUnidad: "",
        subtotal: "",
        pendiente_entrega: 0,
      });
    }
  };

  const handleShowEliminar = (item, index) => {
    setCurrentItemIndex(index);
    setCurrentItem(item);
    setShowEliminar(true);
  };

  const eliminar = () => {
    const index = currentItemIndex;
    const ventaActual = JSON.parse(localStorage.getItem("ventaRapida")) || [];

    if (index >= 0 && index < ventaActual.length) {
      // quitar el elemento con splice
      ventaActual.splice(index, 1);

      // actualizar el localStorage
      localStorage.setItem("ventaRapida", JSON.stringify(ventaActual));

      // actualizar el estado
      setventaR(ventaActual);
      setShowEliminar(false);
    }
  };

  // metodo para verificar el cliente antes de registrar la compra
  const verificarCliente = async (e) => {
    e.preventDefault();
    const cedula = formDataPersona.cedula?.trim();
    if (!cedula) {
      setMensaje("Por favor ingrese una cédula válida");
      setTimeout(() => setMensaje(""), 3000);
      return;
    }

    try {
      setLoading(true);
      const res = await BuscarCliente(cedula);
      //Es lo primero que se debe hacer para ver la estructura de la data

      setControl(res?.success);
      if (res?.success && res.data) {
        const cliente = res.data;

        // ✅ Actualiza los datos del cliente encontrado
        setFormDataPersona((prev) => ({
          ...prev,
          cedula: cliente.cedula || cedula,
          nombre: cliente.nombre || "",
          apellido: cliente.apellido || "",
          direccion: cliente.direccion || "",
          celular: cliente.celular || "",
        }));

        // ✅ Guarda info adicional
        setCurrentPersona(cliente);
        setIdCliente(cliente.Clientes?.[0]?.id || "");
        setCurrentCliente(cliente.Clientes || []);

        setMensaje("Cliente encontrado ✅");
      } else {
        // 🚫 Cliente no existe
        setIdCliente("");
        setCurrentPersona([]);
        setCurrentCliente([]);
        setFormDataPersona((prev) => ({
          ...prev,
          nombre: "",
          apellido: "",
          direccion: "",
          celular: "",
        }));

        setMensaje("El cliente no existe ❌");
      }
    } catch (error) {
      console.error("Error verificando cliente:", error);
      setMensaje("Error al verificar el cliente");
    } finally {
      setLoading(false);
      setTimeout(() => setMensaje(""), 3000);
    }
  };

  const crearCliente = async (debeActualizar = false) => {
    if (!control || control === false) {
      const resP = await PostPersona(formDataPersona);
      if (resP.success) {
        const rescliente = await PostCliente(resP.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id;
      }
      // La cédula ya existe pero no se verificó — buscarla y reutilizarla
      const existing = await BuscarCliente(formDataPersona.cedula);
      if (existing?.success && existing.data) {
        setControl(true);
        setCurrentPersona(existing.data);
        setCurrentCliente(existing.data.Clientes || []);
        const existingId = existing.data.Clientes?.[0]?.id;
        if (existingId) {
          setIdCliente(existingId);
          return existingId;
        }
        const rescliente = await PostCliente(existing.data.idP);
        setIdCliente(rescliente?.data?.id);
        return rescliente?.data?.id;
      }
    } else if (currentCliente.length === 0) {
      const rescliente = await PostCliente(currentPersona?.idP);
      setIdCliente(rescliente?.data?.id);
      if (debeActualizar) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return rescliente?.data?.id; // ✅ devolvemos el ID
    } else {
      // Si ya existe cliente actual, devolvemos su ID directamente
      if (debeActualizar) {
        await EditarPersona(currentPersona?.idP, formDataPersona);
      }
      return currentCliente[0]?.id;
    }
  };

  const crearVentaRapida = async () => {
    try {
      const clienteId = await crearCliente(checkboxes.debeActualizarCliente);

      const data = {
        ...formDataCliente,
        nombre: formDataPersona.nombre || formDataCliente.nombre,
        cedula: formDataPersona.cedula || formDataCliente.cedula,
        telefono: formDataPersona.celular || formDataCliente.telefono,
        direccion: formDataCliente.direccion || formDataPersona.direccion,
        id_cliente: clienteId,
        total: totalventas,
        estado: checkboxes.isCheckedpago ? "1" : totalPendiente > 0 ? "2" : "0",
      };

      if (ventaR.length <= 0) {
        setMensaje("Por lo menos debe agregar un producto a vender");
      } else if (
        formDataPersona.nombre === "" ||
        formDataPersona.cedula === "" ||
        formDataPersona.apellido === ""
      ) {
        setMensaje("El campo nombre, apellido y cedula son obligatorio**");
      } else {
        if (checkboxes.isCheckedpago && data.fecha_vencimiento === null) {
          setMensaje("Fecha de pago es obligatoria**");
          setTimeout(() => {
            setMensaje("");
          }, 5000);
          return;
        }
        const tieneDescripcionAbono = checkboxes.isCheckedpago && descripcionAbono?.trim();
        if (isTipo !== "cotizacion" && !tieneDescripcionAbono && (!checkboxes.isCheckedDescripcion || !formDataCliente.descripcionElaboracion?.trim())) {
          setMensaje("Antes de realizar la venta es obligatorio activar y agregar la descripción de pago");
          setTimeout(() => setMensaje(""), 5000);
          return;
        }
        setShowVenta(true);
        setLoading(true);

        const ventaRapida = await PostventaRapida(data);
        if (ventaRapida.res?.success) {
          const detalle = await postventaRapidaDetalle(
            ventaRapida?.res?.data?.id,
            ventaR
          );
          if (detalle?.status === 201) {
            serIdfactura(ventaRapida?.res?.data?.id);
            setMensajealerta(ventaRapida.res?.msg);
            localStorage.removeItem("ventaRapida");
            setventaR([]);
          }
          if (formDataCliente.total_pagado > 0) {
            let descripcion = "Abono inicial " + descripcionAbono;
            const res = await postAbonoVR(
              ventaRapida?.res?.data?.id,
              formDataCliente.total_pagado,
              descripcion,
              idUser,
              fecha_abono,
              hora_abono
            );
          }

          setFormDataCliente({
            id_user: idUser,
            fecha_vencimiento: null,
            nombre: "",
            cedula: "",
            direccion: "",
            telefono: "",
            transporte: 0,
            total_pagado: 0,
            fecha_creacion: null,
            tipo: isTipo,
          });

          // ✅ Limpiar todos los checkboxes
          setCheckboxes({
            isChecked: false,
            isCheckedDescuento: false,
            isCheckedpago: false,
            isCheckedPendiente: false,
            istransporte: false,
            debeActualizarCliente: false,
          });
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      // 👈 se ejecuta siempre
      setLoading(false);
    }

    setTimeout(() => {
      setAlert(false);
      setMensaje("");
    }, 5000);
  };

  const verificarfactura = async () => {
    // window.location.href = `/generarfacturaventaR/${idfactura}`;
    await abrirPdfVentasRapidas(idfactura);
    navigate(isTipo === "cotizacion"  ? '/cotizaciones-realizadas' : '/venta-realizadas');
  };

  //Metodo para traer todo los transporte 
  const fetchTransporte = async (filters = {}) => {
    try {
      const res = await getTransporte(filters);
      setDatTransporte(res?.data);
    } catch (error) {
      console.error('Error al obtener los transportes:', error);
    }
  };

  useEffect(() => {
    fetchTransporte();
  }, []);


  //Metodo para obtener los transportes
  const obtenerdatosTransporte = (idSeleccionado) => {
    const transporteEncontrado = dataTransporte.find(
      (item) => item.id === idSeleccionado
    );

    if (!transporteEncontrado) return null;

    return {
      nombre: transporteEncontrado.Persona?.nombre,
      apellido: transporteEncontrado.Persona?.apellido,
      celular: transporteEncontrado.Persona?.celular,

    };
  };


  return (
    <Fragment>
      <div className="d-flex justify-content-center">
        <AlertComponent
          styleGroup="bg-soccess color-white"
          mensaje={mensajealerta}
          activaalert={alert}
        />
      </div>
      <HeaderComponent styleGroup="">
        <TitleH2Component styleGroup="box-text color-dark fw700 roboto mb-4">
          {isTipo === "venta"
            ? "VENDER"
            : isTipo === "cotizacion"
              ? "COTIZAR"
              : "ELABORAR"}{" "}
        </TitleH2Component>
      </HeaderComponent>

      <div className="conatiner-global pt-3 pb-5">
        <section className="mb-3 border border-dark rounded p-3">
          <form action="" onSubmit={verificarCliente}>
            <div className="container">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-1">
                INFORMACION DEL COMPRADOR
              </TitleH4Component>
              <div
                className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
              >
                <input
                  className=" me-2"
                  type="checkbox"
                  value=""
                  id="debeActualizarCliente"
                  checked={checkboxes.debeActualizarCliente}
                  onChange={handleCheckboxChange}
                />
                <label className="color-madera fw700" htmlFor="recorddat">
                  Actualizar información cliente
                </label>
              </div>

              <div className="row gy-4 d-flex  align-items-center mb-4">
                {/**d-flex justify-content-end align-items-end*/}
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Documento"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Documento"
                    value={formDataPersona.cedula}
                    name="cedula"
                    onChange={handleInputChangePersona}
                  //onKeyDown={handleKeyDown}
                  />
                  {!alert && (
                    <ParrafoComponent styleGroup="mt-2 color-danger fw400 WorkSans">
                      {mensaje}
                    </ParrafoComponent>
                  )}
                </div>

                <div className="col-12 col-md-6 col-xl-3">
                  <button
                    type="submit"
                    className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                  >
                    Verificar Cliente
                  </button>
                </div>
              </div>
              <div className="row gy-4 ">
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Nombre"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Nombre"
                    value={formDataPersona.nombre}
                    name="nombre"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Apellido"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Ingrese Apellido"
                    value={formDataPersona.apellido}
                    name="apellido"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Telefono"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar telefono"
                    type="text"
                    value={formDataPersona.celular}
                    name="celular"
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Direccion"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    placeholder="Ingresar dirección"
                    type="text"
                    name="direccion"
                    value={formDataPersona.direccion}
                    onChange={handleInputChangePersona}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Quien Recibe"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Recibido"
                    value={formDataCliente.quien_recibe}
                    name="quien_recibe"
                    onChange={handleInputChangeCliente}
                  />
                </div>
                <div className="col-12 col-md-6 col-xl-3">
                  <InputComponent
                    label="Direccion de envio"
                    styleLabel="fw600 WorkSans"
                    styleGroup="me-2"
                    htmlFor="bloque"
                    type="text"
                    placeholder="Direccion"
                    value={formDataCliente.direccion}
                    name="direccion"
                    onChange={handleInputChangeCliente}
                  />
                </div>
              </div>
            </div>
          </form>
        </section>
        <Fragment>
          <div className="container-fluid border border-dark rounded p-2">
            <form action="" className="mt-3">
              <TitleH4Component styleGroup="box-text color-madera text-center fw700 roboto mb-4">
                REGISTRAR PRODUCTO A{" "}
                {isTipo === "venta"
                  ? "VENDER"
                  : isTipo === "cotizacion"
                    ? "COTIZAR"
                    : "ELABORAR"}
              </TitleH4Component>

              <div className="row d-flex align-items-center ">
                <div className="col-12 col-sm-6 col-lg-2">
                  <InputComponent
                    label="Cantidad"
                    placeholder="0"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={formData.cantidad}
                    onChange={handleInputChange}
                  />
                </div>
                {isTipo !== "elaboracion" && (
                  <div className="col-12 col-sm-6 col-lg-4">
                    <InputComponent
                      label="Producto"
                      placeholder="Ingerse producto"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="text"
                      name="producto"
                      value={formData.producto}
                      onChange={handleInputChange}
                    />
                  </div>
                )}
                <div className="col-12 col-sm-6 col-lg-2">
                  <MoneyInputComponent
                    label="Precio unidad"
                    //placeholder="Ingerse precios"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    //styleGroup={`${stylegeneral.col}`}
                    type="number"
                    value={formData.precioUnidad}
                    name="precioUnidad"
                    onChange={handleInputChange}
                  />
                </div>
                {tipoVenta && (
                  <div className="col-12 col-sm-6 col-lg-2">
                    <InputComponent
                      label="Pend. de entrega"
                      placeholder="0"
                      styleLabel="fw600 WorkSans"
                      styleGroup=" mb-2"
                      htmlFor="bloque"
                      type="number"
                      name="pendiente_entrega"
                      value={formData.pendiente_entrega}
                      onChange={handleInputChange}
                    />
                  </div>
                )}

                {isTipo === "elaboracion" && <div className="col-12">
                  <TextAreaComponent
                    label="Descripción"
                    placeholder="Ingrese descripción detallada del producto"
                    styleLabel="fw600 WorkSans"
                    styleGroup="mb-2"
                    name="producto"
                    value={formData.producto}
                    onChange={handleInputChange}
                    rows={4}
                  />
                </div>}
                <div className="col-12 d-flex justify-content-end">
                  <button
                    type="button"
                    onClick={aggVentarapida}
                    className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                  >
                    Registrar
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className=" mt-4">
            <ParrafoComponent styleGroup=" color-madera fw700 WorkSans ">
              Total factura : ${" "}
              {(
                Number(totalventas) +
                Number(formDataCliente.transporte ?? 0) -
                Number(formDataCliente.descuento ?? 0)
              ).toLocaleString("es-ES")}
            </ParrafoComponent>
            <ParrafoComponent styleGroup=" color-madera fw700 WorkSans ">
              Pendiente de pago : ${" "}
              {formDataCliente.total_pagado > 0
                ? (
                  Number(totalventas) +
                  Number(formDataCliente.transporte ?? 0) -
                  Number(formDataCliente.descuento ?? 0) -
                  Number(formDataCliente.total_pagado ?? 0)
                ).toLocaleString("es-ES")
                : 0}
            </ParrafoComponent>
            <div className="table-responsive">
              <table className="table table-bordered tableGeneral">
                <thead>
                  <tr>
                    <th scope="col " className="color-madera">
                      #
                    </th>

                    <th scope="col " className="color-madera">
                      Cant.
                    </th>
                    <th scope="col " className="color-madera">
                      Producto
                    </th>

                    {tipoVenta && (
                      <th scope="col " className="color-madera">
                        Pend. entrega
                      </th>
                    )}
                    <th scope="col" className="color-madera">
                      Precio/unidad
                    </th>
                    <th scope="col" className="color-madera">
                      Subtotal
                    </th>
                    <th scope="col" className="color-madera text-center">
                      Editar
                    </th>
                    <th scope="col" className="color-madera text-center">
                      Eliminar
                    </th>
                  </tr>
                </thead>
                {ventaR.length !== 0 ? (
                  <tbody>
                    {ventaR.map((item, index) => {
                      return (
                        <tr key={index}>
                          <th>{index + 1}</th>
                          <td className="text-center">{item.cantidad}</td>
                          <th className="text-center">{item.producto}</th>
                          {tipoVenta && (
                            <td className="text-center">
                              {item.pendiente_entrega}
                            </td>
                          )}
                          <td className="text-center">
                            ${" "}
                            {Number(item.precioUnidad).toLocaleString("es-ES")}
                          </td>
                          <td className="text-center">
                            $ {Number(item.subtotal).toLocaleString("es-ES")}
                          </td>
                          <td>
                            <button
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex`}
                              onClick={() => handleShowEdit(item, index)}
                            >
                              <Icon icon="raphael:edit" />
                            </button>
                          </td>
                          <td>
                            <button
                              className={`${stylebtn.btn_desnudo} ${stylebtn.icon} ms-3 p-0 d-inline-flex color-danger`}
                              onClick={() => handleShowEliminar(item, index)}
                            >
                              <Icon icon="majesticons:delete-bin" />
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan={8} className="text-center">
                        SIN DATOS
                      </td>
                    </tr>
                  </tbody>
                )}
              </table>
            </div>

            {!alert && (
              <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                {mensaje}
              </ParrafoComponent>
            )}
            <section className="mb-3">
              <div className="container">
                <div className="row gy-3 align-items-end">
                  {/* Columna izquierda: check + fecha */}
                  <div className="col-12 col-md-6 col-xl-3">
                    {isSuper && (
                      <InputComponent
                        label="Fecha de Facturación"
                        styleLabel="fw600 WorkSans"
                        styleGroup="mb-3"
                        htmlFor="bloque"
                        placeholder="Ingresar fecha"
                        type="date"
                        name="fecha_creacion"
                        value={formDataCliente.fecha_creacion}
                        onChange={handleInputChangeCliente}
                      />
                    )}
                    {/* Checkbox arriba */}
                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        value=""
                        id="istransporte"
                        checked={checkboxes.istransporte}
                        onChange={handleCheckboxChange}
                      />
                      <label className="color-madera fw700" htmlFor="recorddat">
                        Transporte
                      </label>
                    </div>
                    {checkboxes.istransporte && (
                      <>
                        <MoneyInputComponent
                          label="Valor transporte"
                          placeholder="Ingrese transporte"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-3"
                          htmlFor="transporte"
                          type="number"
                          name="transporte"
                          value={formData.transporte}
                          onChange={handleInputChangeCliente}
                        />

                        <SelectComponent
                          label="Transporte"
                          styleGroup={`${stylegeneral.wselect}`}
                          styleLabel="fw600 WorkSans color-madera mb-1"
                          options={dataTransporte.map((transporte) => ({
                            value: transporte.id,
                            label:
                              transporte?.Persona?.nombre +
                              " " +
                              transporte?.Persona?.apellido,
                          }))}
                          capOpcions={(v) => {
                            setTransporteID(v);
                            const datos = obtenerdatosTransporte(v);

                            if (datos) {
                              setFormDataCliente((prev) => ({
                                ...prev,
                                nombre_conductor: `${datos?.nombre} ${datos?.apellido}`,
                                celular_conductor: datos.celular,
                              }));
                            }
                          }}
                          customPlaceholder="Seleccionar"
                          name="transporte"
                          value={
                            dataTransporte.find(
                              (o) => o.value == transporteID,
                            ) || null
                          }
                          isClearable
                        />
                        <div className="mt-2">
                          {formDataCliente.nombre_conductor && (
                            <ParrafoComponent styleGroup=" color-madera fw400 WorkSans my-2">
                              Nombre: {formDataCliente.nombre_conductor}
                            </ParrafoComponent>
                          )}
                          {formDataCliente?.celular_conductor && (
                            <ParrafoComponent styleGroup=" color-madera fw400 WorkSans mb-2">
                              Celular: {formDataCliente?.celular_conductor}
                            </ParrafoComponent>
                          )}
                          {/*<InputComponent
                            label="Nombre del conductor"
                            styleLabel="fw600 WorkSans"
                            styleGroup="mb-3"
                            htmlFor="bloque"
                            placeholder="Nombre del conductor"
                            type="text"
                            name="nombre_conductor"
                            value={formDataCliente?.nombre_conductor}
                            onChange={handleInputChangeCliente}
                          />
                          <InputComponent
                            label="Numero de celular"
                            styleLabel="fw600 WorkSans"
                            styleGroup="mb-3"
                            htmlFor="bloque"
                            placeholder="3*******"
                            type="text"
                            name="celular_conductor"
                            value={formDataCliente?.celular_conductor}
                            onChange={handleInputChangeCliente}
                          />*/}
                        </div>
                      </>
                    )}
                    {tipoVenta && (
                      <div
                        className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                      >
                        <input
                          className=" me-2"
                          type="checkbox"
                          value=""
                          id="isCheckedpago"
                          checked={checkboxes.isCheckedpago}
                          onChange={handleCheckboxChange}
                        />
                        <label
                          className="color-madera  fw700"
                          htmlFor="recorddat"
                        >
                          Abono
                        </label>
                      </div>
                    )}
                    {checkboxes.isCheckedpago && (
                      <div>
                        <MoneyInputComponent
                          //label="Valor a Pagar"
                          placeholder="Ingrese precio"
                          styleLabel="fw600 WorkSans"
                          styleGroup=" mb-2"
                          //styleGroup={`${stylegeneral.col}`}
                          type="number"
                          name="total_pagado"
                          value={formData.total_pagado}
                          onChange={handleInputChangeCliente}
                        />
                        <InputComponent
                          label="Fecha Pendiente de Pago*"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-2"
                          htmlFor="fechaPago"
                          type="date"
                          name="fecha_vencimiento"
                          value={formData.fecha_vencimiento}
                          onChange={handleInputChangeCliente}
                        />

                        <textarea
                          label="descripcion"
                          name="descripcionAbono"
                          placeholder="Descripción"
                          className="form-control mb-2"
                          rows={3}
                          value={descripcionAbono}
                          onChange={handleChangeDescripcion}
                        ></textarea>

                        <InputComponent
                          label="Fecha del abono"
                          styleLabel="fw600 WorkSans"
                          styleGroup="mb-2"
                          htmlFor="bloque"
                          type="date"
                          name="fecha_abono"
                          value={fecha_abono}
                          onChange={handleChangeFechaAbono}
                        />

                        <InputComponent
                          styleLabel="fw600 WorkSans"
                          htmlFor="bloque"
                          label="Hora del abono"
                          type="time"
                          value={hora_abono}
                          name="hora_abono"
                          onChange={handleChangeHoraAbono}
                        />

                        <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                          {mensaje}
                        </ParrafoComponent>
                      </div>
                    )}
                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        value=""
                        id="isCheckedDescuento"
                        checked={checkboxes.isCheckedDescuento}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="color-madera  fw700"
                        htmlFor="recorddat"
                      >
                        Descuento
                      </label>
                    </div>
                    {checkboxes.isCheckedDescuento && (
                      <div>
                        <MoneyInputComponent
                          placeholder="Ingrese precio"
                          styleLabel="fw600 WorkSans"
                          styleGroup=" mb-2"
                          //styleGroup={`${stylegeneral.col}`}
                          type="number"
                          name="descuento"
                          value={formData.descuento}
                          onChange={handleInputChangeCliente}
                        />

                        <ParrafoComponent styleGroup="text-center color-danger fw400 WorkSans">
                          {mensaje}
                        </ParrafoComponent>
                      </div>
                    )}
                    {/**DESCRCIPCION */}
                    <div
                      className={`${styleform.checkbox} d-flex justify-content-start mb-2`}
                    >
                      <input
                        className=" me-2"
                        type="checkbox"
                        id="isCheckedDescripcion"
                        checked={checkboxes.isCheckedDescripcion}
                        onChange={handleCheckboxChange}
                      />
                      <label
                        className="color-madera  fw700"
                        htmlFor="recorddat"
                      >
                        Descripción de pago
                      </label>
                    </div>

                    {checkboxes.isCheckedDescripcion && (
                      <div>
                        <textarea
                          label="descripcion"
                          name="descripcionElaboracion"
                          placeholder="Descripción"
                          className="form-control mb-2"
                          rows={3}
                          value={formDataCliente?.descripcionElaboracion}
                          onChange={handleInputChangeCliente}
                        ></textarea>
                      </div>
                    )}
                  </div>

                  {/* Botón totalmente a la derecha */}
                  <div className="col d-flex justify-content-end">
                    <button
                      type="submit"
                      className={`${stylebtn.btn} ${stylebtn.primary}  mt-4`}
                      onClick={crearVentaRapida}
                    >
                      {isTipo === "venta"
                        ? "VENDER"
                        : isTipo === "cotizacion"
                          ? "COTIZAR"
                          : "ELABORAR"}
                    </button>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </Fragment>
      </div>

      {/** modal eliminar un producto del carrito **/}
      <section>
        <ModalGeneralComponent
          styleGroup="d-flex align-items-center modal-general "
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showEliminar}
          handleClose={handleCloseEliminar}
        >
          <form action="">
            <TitleH2Component styleGroup="box-text color-madera fw700 roboto mb-4 text-center">{`Seguro que quiere eliminar el producto con nombre ${currentItem?.producto} ?`}</TitleH2Component>

            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleCloseEliminar}
                className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
              >
                Cancelar
              </button>
              <button
                type="button"
                className={`btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                onClick={eliminar}
              >
                SI
              </button>
            </div>
          </form>
        </ModalGeneralComponent>
      </section>

      {/** modal editar informacion de venta rapdia**/}
      <section>
        <ModalGeneralComponent
          ModalHeader
          titulo="Editar la Informacion"
          styleGroup={`d-flex align-items-center modal-general `}
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showEdit}
          handleClose={handleCloseEdit}
        >
          <form action="">
            <div className="container">
              <div className="row">
                <div className="col-12 col-sm-6">
                  <InputComponent
                    label="Cantidad"
                    placeholder="Ingerse producto"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="cantidad"
                    value={formData.cantidad}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <InputComponent
                    label="Producto"
                    placeholder="Ingerse producto"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="text"
                    name="producto"
                    value={formData.producto}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <MoneyInputComponent
                    label="Precio"
                    placeholder="Ingerse precio"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    value={formData.precioUnidad}
                    onChange={handleInputChange}
                    name="precioUnidad"
                  />
                </div>
                <div className="col-12 col-sm-6">
                  <InputComponent
                    label="Pendiente por entregar"
                    placeholder="Ingerse cantidad"
                    styleLabel="fw600 WorkSans"
                    styleGroup=" mb-2"
                    htmlFor="bloque"
                    type="number"
                    name="pendiente_entrega"
                    value={formData.pendiente_entrega}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end">
              <button
                type="button"
                onClick={handleCloseEdit}
                className={`btn ${stylebtn.btn} ${stylebtn.danger} `}
              >
                Cancelar
              </button>
              <button
                type="button"
                className={` btn ${stylebtn.btn} ${stylebtn.primary} ms-3`}
                onClick={editarVentaRapida}
              >
                Continuar
              </button>
            </div>
          </form>
        </ModalGeneralComponent>
      </section>

      {/** modal ingresar informacion del cliente **/}
      <section>
        <ModalGeneralComponent
          ModalHeader={false}
          titulo="Información del cliente"
          styleGroup={`d-flex align-items-center modal-general `}
          styleBody={`${"bg-gris-modal "}`}
          styleTitle={"box-text color-madera fw700 roboto text-center WorkSans"}
          show={showventa}
          handleClose={handleCloseVenta}
        >
          {loading ? (
            <LoaderComponent styleGroup="mt-5" />
          ) : (
            <div>
              <div className="d-flex justify-content-end mb-0 align-items-center mb-3">
                <button
                  type="button"
                  onClick={verificarfactura}
                  className={`btn ${stylebtn.btn} ${stylebtn.primary} me-3`}
                >
                  Generar factura
                </button>
                <button
                  type="button"
                  className={`btn ${stylebtn.btn_desnudo} ${stylebtn.icon} p-0 d-inline-flex`}
                  onClick={handleCloseVenta}
                >
                  <Icon icon="mdi:close-thick" />
                </button>
              </div>
              <TitleH2Component styleGroup="box-text color-soccess fw700 roboto mb-0 text-center WorkSans">
                {mensajealerta}
              </TitleH2Component>
            </div>
          )}
        </ModalGeneralComponent>
      </section>
    </Fragment>
  );
};

export default VentaRapidasPages;
